/**
 * "This address already belongs to someone — replace their login?"
 *
 * ONE confirmation for every screen that hands portal access out: the
 * Operators screen's Portal users modal, and an operator inviting its own
 * drivers. Both grant through the same endpoint and can hit the same
 * refusal, so they ask the same question, in the same words
 * (Utils/portalLogins' `replaceWarning`), and re-submit the same way.
 *
 * It only ever appears for STAFF. The operator portal's own invite endpoint
 * answers an address that is taken with one generic sentence and no code,
 * so `emailHeldBy` finds nothing there and this never renders — an operator
 * cannot learn that an address has a login elsewhere, let alone take it.
 *
 * It is also only ever offered for a REVOKED login. A working one comes
 * back `replaceable: false`, which the caller shows as a plain error
 * ("revoke that login first") rather than an offer.
 *
 * Confirm re-submits the grant with the explicit flag; cancel changes
 * nothing at all — no request was made, and none is made now.
 */
import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { replaceWarning } from '../../../Utils/portalLogins';

export default function PortalTakeoverConfirm({
  held, grantingKind, busy = false, onConfirm, onCancel,
}) {
  if (!held) return null;

  return (
    <Modal show onHide={onCancel} backdrop="static" aria-labelledby="portal-takeover-title">
      <Modal.Header closeButton>
        <Modal.Title as="h6" id="portal-takeover-title">
          Replace the existing login?
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-0">{replaceWarning(held, grantingKind)}</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onCancel} disabled={busy}>
          Cancel
        </Button>
        <Button variant="danger" onClick={onConfirm} disabled={busy}>
          <i className="fa fa-triangle-exclamation me-2" />
          Replace login
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
